import { Center, Spinner } from '@chakra-ui/react';

export const LoadingSpinner = () => {
  return (
    <Center minH="100vh" bg="#fffaf5">
      <Spinner
        thickness="4px"
        speed="0.65s"
        emptyColor="gray.200"
        color="whatsapp.500"
        size="xl"
      />
    </Center>
  );
};